<template>
  <div>
    <el-card class="box-card">
      <el-form :model="search">
        <el-row>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="方法描述" :label-width="formLabelWidth" prop="username">
              <el-input v-model="search.description" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="24" :lg="12">
            <el-form-item label="时间" :label-width="formLabelWidth" prop="createTime">
              <el-date-picker
                v-model="search.time"
                value-format="yyyy-MM-dd"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
              <a class="mainColor" @click="reset">重置</a>
            <el-button type="primary" @click="index">查询</el-button>
            <!-- <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button> -->
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="width: 100%;"
        border
        @selection-change="selectionChange"
        v-if="permissions.indexOf('列表') > -1"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="method" label="方法名" width="200"></el-table-column>
        <el-table-column prop="param" label="请求参数" width="600"></el-table-column>
        <el-table-column prop="description" label="方法描述" width="200"></el-table-column>
        <el-table-column prop="createTime" label="日期"></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, prev, pager, next"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
        v-if="permissions.indexOf('列表') > -1"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "id",
        sortOrder: "asc"
      },
      search: {
        description: "",
        time: ""
      },
      addForm: {
        username: "",
        password: "",
        role: [],
        roleList: []
      },
      editForm: {
        id: "",
        username: "",
        password: "",
        role: [],
        roleList: []
      },
      formLabelWidth: "80px",
      multipleSelection: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      permissions: []
    };
  },
  methods: {
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    selectionChange(val) {
      this.multipleSelection = val;
    },
    list() {
      this.axios({
        method: "get",
        url: "/log/list",
        params: {
          description: this.search.description,
          startTime: this.search.time[0],
          endTime: this.search.time[1],
          pageSize: this.page.pageSize,
          pageNumber: this.page.pageNumber,
          sortName: this.page.sortName,
          sortOrder: this.page.sortOrder
        }
      })
        .then(result => {
          this.page.rows = result.data.rows;
          this.page.total = result.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    reset() {
      this.search.description = "";
      this.search.time = "";
      this.page.pageSize = 10;
      this.page.pageNumber = 1;
      this.page.sortName = "";
      this.page.sortOrder = "";
    }
  },
  watch: {},
  mounted() {
    this.pageList();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/log/index.vue